import { exportsModule } from '@cian/mf-registry/browser';
import { createCustomElementConstructor } from './createCustomElementConstructor';
import { createApplicationContext } from '../services/createApplicationContext';
import { createApplicationState } from '../services/applicationState';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  exportsModule({
    ui: {
      '/offer-calculator/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
      '/v1/get-offer-calculator-by-post/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
  });
}
